import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { CONTACT_EMAIL, SOCIAL_LINKS } from "../../config/socials";

const SITE_URL = "https://coval-tech.com";
const LOGO_URL = `${SITE_URL}/logo-400x400.png`;

const SeoHead = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage ?? "fr";
  const canonicalUrl = `${SITE_URL}/${lang}/`;

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "CovalTech",
    url: SITE_URL,
    logo: LOGO_URL,
    email: CONTACT_EMAIL,
    description: t("seo.description"),
    address: { "@type": "PostalAddress", addressCountry: "BE" },
    sameAs: [SOCIAL_LINKS.linkedin, SOCIAL_LINKS.github],
    serviceArea: { "@type": "Country", name: "Belgium" },
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "CovalTech",
    url: SITE_URL,
    inLanguage: ["fr", "en"],
    publisher: { "@type": "Organization", name: "CovalTech" },
  };

  return (
    <Helmet>
      <html lang={lang} />
      <title>{t("seo.title")}</title>
      <meta name="description" content={t("seo.description")} />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="fr" href={`${SITE_URL}/fr/`} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}/en/`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/`} />
      <meta property="og:title" content={t("seo.title")} />
      <meta property="og:description" content={t("seo.description")} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content={lang === "fr" ? "fr_BE" : "en_US"} />
      <meta
        property="og:locale:alternate"
        content={lang === "fr" ? "en_US" : "fr_BE"}
      />
      <meta name="twitter:title" content={t("seo.title")} />
      <meta name="twitter:description" content={t("seo.description")} />
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
};

export default SeoHead;

